import { type Route } from '#app/routes/mocra+/_sections+/+types/606.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — §606 Good Manufacturing Practice Preparation' },
]

export default function Section606() {
	return <SectionDetail section={SECTIONS['606']} />
}
